import { render, staticRenderFns } from "./ThemaCard.vue?vue&type=template&id=70587623&"
import script from "./ThemaCard.vue?vue&type=script&lang=js&"
export * from "./ThemaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports